import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { ICategoryAssignments } from "../../interface/ICategoryAssignments";
import { shallowEqual } from "react-redux";
import { ILocation } from "../../interface/ILocation";
import { ISession } from "../../interface/ISession";
import { IEvent } from "../../interface/IEvent";
import { Token } from "../../interface/Token";
import { IOrder } from "../../interface/IOrder";
import { useTokenTP } from "../../features/useTokenTP";
import { usePostUserTokenMutation } from "../../features/CallTPApi";
import { usePostSetOrderStatusMutation } from "../../features/CallTPApi";
import { useDispatch } from "react-redux";
import { ISeat } from "../../interface/ISeat";
import { ISector } from "../../interface/ISector";
import { setOrderInStore } from "../../features/orderSlice";
import { setAlertMsgStore } from "../../features/alertMsgSlisce";
import { FullScreenLoader } from "../UI/FullScreenLoader";
import { Button, Container, Offcanvas, Spinner } from "react-bootstrap";
import { format } from "date-fns";
import { ru } from "date-fns/locale";
import { NumericFormat } from "react-number-format";
import { DeleteItemButton } from "./DeleteItemButton";
import { CountdownOrderTimer } from "./CountdownOrderTimer";
import { InputPhone } from "./InputPhone";
import { PersonForm } from "./PersonForm";
import { ym } from "react-metrika";
import { IPerson } from "../../interface/IPerson";

export const PayPanel = ({ setReqRefetch }: { setReqRefetch: (state: boolean) => void, getOrderInStroe: (state: any) => void }) => {
    const basket = useSelector((state: any) => state.basket, shallowEqual) as any[];
    const [basketItems, setBasketItems] = useState<any>([]);
    const sessionAssignments = useSelector((state: any) => state.sessionAssignments, shallowEqual) as ICategoryAssignments[];
    const location = useSelector((state: any) => state.locationScheme, shallowEqual) as ILocation;
    const session = useSelector((state: any) => state.session, shallowEqual) as ISession;
    const event = useSelector((state: any) => state.event, shallowEqual) as IEvent;
    const [summ, setSumm] = useState<number>(0)
    const [showOffcanvas, setShowOffcanvas] = useState<boolean>(false);
    const token = useSelector((state: any) => state.token, shallowEqual) as Token;
    const feature = useSelector((state: any) => state.feature) as string
    const { setTokenTP } = useTokenTP()
    const [postUserToken, { isLoading }] = usePostUserTokenMutation()
    const order = useSelector((state: any) => state.order, shallowEqual) as IOrder;
    const whoami = useSelector((state: any) => state.whoamiTP) as IPerson
    // const personId = localStorage.getItem('personId')
    const [postSetOrderStatus, { isLoading: isLoadingOrderStatus }] = usePostSetOrderStatusMutation()
    const dispatch = useDispatch()


    useEffect(() => {
        if (token.value && !feature) {
            postUserToken(null).then((r: any) => {
                if (r.error) {
                    return;
                }
                setTokenTP(r.data.token);
            });
        }
    }, [token])

    useEffect(() => {
        if (showOffcanvas && basket.length == 0) {
            returnBasketStatus()
        }
    }, [basket])

    useEffect(() => {
        if (!location) {
            return;
        }
        if (!basket) {
            return;
        }
        const newbasketItems = basket.map(item => {
            const itemAssignment = sessionAssignments.find((cat: ICategoryAssignments) => cat.targetId === item.id) as ICategoryAssignments;
            const sector = location.sectors.find((sector: ISector) => sector.seats.some((seat: ISeat) => seat.id === item.id));
            const seat = sector ? sector.seats.find((seat: ISeat) => seat.id === item.id) : undefined;
            return {
                id: item.id,
                price: itemAssignment.price,
                color: itemAssignment.color ?? "black",
                categoryName: itemAssignment.name,
                row: seat ? seat.row : undefined,
                seat: seat ? seat.place : undefined,
                quantity: 1,
                priceCategoryAssignmentId: itemAssignment.id,
                priceCategoryTarget: 3
            };
        });
        setBasketItems(newbasketItems)
        setSumm(newbasketItems.reduce((sum, item) => sum + item.price * item.quantity, 0))
        if (newbasketItems.length < 1) {
            setShowOffcanvas(false)
        }
    }, [basket])

    useEffect(() => {
        if (order?.orderStatus === 1) {
            setShowOffcanvas(true)
        }
    }, [order])

    const returnBasketStatus = () => {
        if (whoami) {
            setShowOffcanvas(false)
        }
        postSetOrderStatus({
            id: order.id,
            status: {
                orderStatus: 0,
            }
        }).then((res: any) => {
            if (!res.error) {
                setReqRefetch(true)
                setShowOffcanvas(false)
                // getOrder()
                dispatch(setOrderInStore(res.data as any))
            }
            if (res.error) {
                // dispatch(setAlertMsgStore({ title: "", variant: "danger" } as any))
            }
            console.log(res)
        })

    }

    const expiratedOrder = () => {
        dispatch(setAlertMsgStore({ title: "Время оформления заказа закончилось. Заказ возвращен в корзину.", variant: "danger" } as any))
        returnBasketStatus()
    }

    return (
        <>
            {isLoadingOrderStatus &&
                // <div className="position-relative">
                <FullScreenLoader message="Обновление данных заказа..." />

            }
            <Offcanvas show={showOffcanvas} onHide={() => returnBasketStatus()}>
                <Offcanvas.Header closeButton>Оформление заказа</Offcanvas.Header>
                <Offcanvas.Body>
                    <div>Состав заказа</div>
                    {session &&
                        <div>
                            <div className="fs-5">
                                <div className="text-center">
                                    Мероприятие:
                                </div>

                                <div className="text-center">
                                    <b>{event?.name}, {format(new Date(session.startTime).getTime() + 3 * 60 * 60 * 1000, "dd.MM.yyyy")} ({format(new Date(session.startTime).getTime() + 3 * 60 * 60 * 1000, 'EEEE', { locale: ru })})</b>
                                </div>
                            </div>
                            <div className="fs-5 text-center border-bottom">Начало: <b>{format(new Date(session.startTime).getTime() + 3 * 60 * 60 * 1000, "HH:mm")}</b>
                            </div>
                        </div>
                    }
                    {basketItems.map((item: any) =>
                        <div key={item.id} className="border-bottom pt-2 pb-2 d-flex">
                            <div className="me-3">
                                <div>
                                    <strong><span style={{ color: `${item.color}` }}>{item.categoryName}</span>, <NumericFormat displayType={'text'} value={item.price} allowLeadingZeros thousandSeparator=" " /> ₽</strong>
                                </div>
                                <div>
                                    {item.row}, место: {item.seat}
                                </div>
                            </div>
                            <div className="flex-fill" style={{ alignContent: 'center', alignItems: 'center', justifyContent: 'center', flexWrap: 'wrap' }}>
                                x  {item.quantity} шт.
                            </div>
                            <DeleteItemButton item={item} />
                        </div>
                    )}
                    <div className="fs-5 pb-3">Итого: <b><NumericFormat displayType={'text'} value={summ} allowLeadingZeros thousandSeparator=" " /></b> ₽</div>
                    {order?.orderStatus === 1 &&
                        <CountdownOrderTimer callBack={() => { expiratedOrder() }} />
                    }
                    <div>
                    </div>

                    {!whoami?.id ?
                        <InputPhone />
                        :
                        <>
                            {!isLoading ?
                                <PersonForm />
                                :
                                <>
                                    <Spinner variant="dark" />
                                </>
                            }
                        </>
                    }
                </Offcanvas.Body>
            </Offcanvas>
            {basketItems.length > 0 &&
                <div className="position-relative">

                    <div className="position-fixed bg-white w-100 shadow-lg p-3" style={{ bottom: 0, zIndex: 1000 }}>
                        <Container className="d-lg-flex justify-content-around">
                            <div>
                                <div className="fs-5"><span>Выбрано билетов:</span> {basket.length} шт., на сумму  <NumericFormat displayType={'text'} value={summ} allowLeadingZeros thousandSeparator=" " /> ₽</div>
                                <div></div>
                            </div>
                            <div className="fs-4"><Button onClick={() => {
                                setShowOffcanvas(true);
                                ym(29087940, 'reachGoal', 'buy'); ym(65160898, 'reachGoal', 'buy')
                            }}
                                className="w-100" variant="dark">Купить</Button> </div>
                        </Container>
                    </div>
                </div>
            }
        </>
    )
}